import { getRoseResponse } from '../services/ai.js';

export function handleRoseMessage() {
  const modal = document.querySelector('.rose-modal');
  const overlay = document.querySelector('.modal-overlay');
  const content = modal.querySelector('.modal-content');
  const closeBtn = modal.querySelector('.close-btn');
  
  modal.classList.add('active');
  overlay.style.display = 'block';
  
  // Initialize conversation
  content.innerHTML = '<div class="message rose">Hello! I am Rose, your AI companion. How can I help you today?</div>';
  
  // Add input field if not exists
  if (!document.getElementById('rose-input')) {
    const inputContainer = document.createElement('div');
    inputContainer.className = 'input-container';
    inputContainer.innerHTML = `
      <input type="text" id="rose-input" placeholder="Type your message...">
      <button id="rose-send">Send</button>
    `;
    modal.appendChild(inputContainer);
    
    // Handle send button
    document.getElementById('rose-send').addEventListener('click', async () => {
      handleRoseSend();
    });
    
    // Handle Enter key
    document.getElementById('rose-input').addEventListener('keypress', (e) => {
      if (e.key === 'Enter') {
        document.getElementById('rose-send').click();
      }
    });
  }
  
  // Handle close button
  closeBtn.addEventListener('click', () => {
    modal.classList.remove('active');
    overlay.style.display = 'none';
    
    // Remove input container if it exists
    const inputContainer = document.querySelector('.input-container');
    if (inputContainer && inputContainer.parentNode === modal) {
      modal.removeChild(inputContainer);
    }
  });
}

// Función auxiliar para Rose
async function handleRoseSend() {
  const content = document.querySelector('.rose-modal .modal-content');
  const input = document.getElementById('rose-input');
  const message = input.value.trim();
  
  if (message) {
    // Add user message
    content.innerHTML += `<div class="message user">${message}</div>`;
    input.value = '';
    
    // Show typing indicator
    content.innerHTML += `<div class="message rose typing">Rose is typing<span class="typing-dots">...</span></div>`;
    content.scrollTop = content.scrollHeight;
    
    try {
      // Get AI response
      const response = await getRoseResponse(message);
      
      // Remove typing indicator
      const typingIndicator = content.querySelector('.typing');
      if (typingIndicator) {
        content.removeChild(typingIndicator);
      }
      
      // Add AI response
      content.innerHTML += `<div class="message rose">${response}</div>`;
    } catch (error) {
      console.error("Rose error:", error);
      
      // Remove typing indicator
      const typingIndicator = content.querySelector('.typing');
      if (typingIndicator) {
        content.removeChild(typingIndicator);
      }
      
      // Add error message
      content.innerHTML += `<div class="message rose">I apologize, but I'm having trouble connecting right now. Please try again later.</div>`;
    }
    
    // Scroll to bottom
    content.scrollTop = content.scrollHeight;
  }
}